import React from 'react'
import { Link } from 'react-router-dom';
import './Error.css'
const Error = () => {
    return (
        <div className='error404'>
            <div className="error404-left">
            <img src="/error404.svg"></img>
             </div>
             <div className="error404-right">
                 <h1>La página no existe en el servidor.
                     Puedes ir a la página principal <Link to="/" >
					 Aquí
					</Link>
                 </h1>
           
             </div>
            
        </div>
    )
}

export default Error
